import safeStorage from './safeStorage';

/**
 * Which platform this dashboard session belongs to.
 *
 * Set when the session starts (the Wix landing page records it) and read
 * wherever the UI must differ per platform.
 */

const PLATFORM_KEY = 'platform';

export const setPlatform = (platform) => {
  if (platform) safeStorage.set(PLATFORM_KEY, String(platform));
};

export const getPlatform = () => safeStorage.get(PLATFORM_KEY) || 'universal';

/**
 * True when running as a Wix App Market app.
 *
 * Wix requires that any app charging money uses the WIX BILLING SYSTEM, and
 * explicitly forbids partners from using "their own mechanisms to unlock
 * content or functionality". Our Stripe checkout is exactly such a mechanism,
 * so every pricing/upgrade surface is hidden when this is true — showing it is
 * a documented App Market rejection trigger.
 *
 * Falls back to sniffing the URL so the very first render (before storage is
 * written) is already correct.
 */
export const isWix = () => {
  if (getPlatform() === 'wix') return true;

  if (typeof window !== 'undefined') {
    try {
      if (new URLSearchParams(window.location.search).get('platform') === 'wix') return true;
      if (window.location.pathname.replace(/\/+$/, '').toLowerCase() === '/wix') return true;
    } catch {
      /* ignore */
    }
  }

  return false;
};

export default { setPlatform, getPlatform, isWix };
